import React from 'react';
import { Trans } from 'react-i18next';
import { Text } from '@wix/design-system';

export const ChargeDetail: React.FC<{
  transkey: string;
  keyValues: Record<string, any>;
  // English fallback rendered when the translation key is missing.
  // Use the same `{{var}}` placeholders as the i18n template so the
  // values from `keyValues` are interpolated into the fallback.
  defaultLabel?: string;
  defaultValue?: string;
}> = ({ transkey, keyValues, defaultLabel, defaultValue }) => {
  return (
    <Text dataHook={`charge-details__${transkey}`} secondary>
      <Trans
        i18nKey={`charge-locator.results-page.field-name.${transkey}`}
        values={keyValues}
        count={keyValues.quantity}
      >
        {defaultLabel ?? 'charge-locator.results-page.'}
        <Text tagName="span" secondary={false} weight="normal">
          {defaultValue ?? `field-name.${transkey}`}
        </Text>
      </Trans>
    </Text>
  );
};
